import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

import { ReportTooltipTemplateContext } from '@core/reports-types';

import { ReportTooltipInnerComponent } from './report-tooltip-inner/report-tooltip-inner.component';

@Component({
  selector: 'reports-tooltip',
  template: `
    @if (context()) {
      <reports-tooltip-inner [context]="context()" [activeId]="activeId()" />
    }
  `,
  styleUrls: ['./report-tooltip.component.less'],
  imports: [ReportTooltipInnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ReportTooltipComponent {
  public context = input.required<ReportTooltipTemplateContext>();
  public activeId = input<string>();
}
